<template>
  <v-col class="restricted-policy-code-box" cols="12">
    <v-row justify="end">
      <v-col shrink class="view-policy-section policy-number">
        <div class="text-white text-subtitle-2">
          {{ $t('L_policy_policy_number') }}:
          <span class="font-weight-regular">
            {{ policyList[selectedPolicyIndex] && policyList[selectedPolicyIndex].contractId }}
          </span>
        </div>
      </v-col>
    </v-row>
    <v-row class="">
      <v-col cols="12" class="restricted-policy-message-box mt-3 pb-5 pt-5">
        <h3 class="heading_three text-center mb-3">
          {{ $t('L_restricted_policy_code_message') }}
        </h3>
        <h3
          v-html="
            $t('L_restricted_policy_code_number', {
              phoneWODash: getCustServNumWODash(locale),
              phoneWDash: getCustServNumWDash(locale),
            })
          "
          class="heading_three text-center"
        ></h3>
      </v-col>
    </v-row>
  </v-col>
</template>

<script lang="ts">
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import type { IPolicyStorePolicy } from '@/modules/policy/store/policyStore.model';
import { useCustomerStore } from '@/stores/customer/customer.store';
import { useGlobalStore } from '@/stores/global/global.store';
import { mapActions, mapState, mapStores } from 'pinia';
import { defineComponent, type ComponentOptions } from 'vue';

const componentOptions: ComponentOptions = {
  name: 'RestrictedPolicy',
  computed: {
    ...mapStores(useGlobalStore, usePolicyStore),
    ...mapState(usePolicyStore, {
      policies: 'policies',
      selectedPolicyIndex: 'selectedPolicyIndex',
    }),
    ...mapState(useCustomerStore, {
      getCustServNumWDash: 'getCustServNumWDash',
      getCustServNumWODash: 'getCustServNumWODash',
    }),
    ...mapState(useGlobalStore, {
      locale: 'getLocale',
    }),
    policyList() {
      return this.policies.map((p: IPolicyStorePolicy) => ({ contractId: p.contractId }));
    },
  },
  methods: {
    ...mapActions(usePolicyStore, {
      changePolicy: 'changePolicy',
    }),
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.policy-items-dropdown {
  position: relative;
  border-radius: 13.5px;
  width: 135px;
  height: 27px;
  background: #ebebeb;
  margin: 0;
  padding: 0px 35px 0 10px;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.1;
  letter-spacing: normal;
  color: #000;

  span {
    font-weight: 600;
  }

  .v-icon {
    position: absolute;
    right: 10px;
    top: 2px;
    color: #2196f3;
  }
}

.policy-number-text {
  font-size: 12px;
  font-weight: 600;
  padding: 0 10px 0 0;
}

.restricted-policy-message-box {
  background-color: rgba(216, 216, 216, 0.95);
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.5) inset;
}
</style>
